<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.UserSettings.Details.Title">
  <ng-container commands *ngIf="viewModel?.form">
    <button class="btn btn-success me-2"
            (click)="save()" [disabled]="!ngForm || ngForm.pristine">
      {{'Common.SearchActionsAndDetailsActions.Save' | translate}}
    </button>
    <button class="btn btn-success me-2"
            (click)="saveAndExit()" [disabled]="!ngForm || ngForm.pristine">
      {{'Common.SearchActionsAndDetailsActions.SaveAndExit' | translate}}
    </button>
    <button class="btn btn-default me-4"
            (click)="back()">
      {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
    </button>
  </ng-container>
  <ng-container body>
    <tcm-details-layout>
      <div *ngIf="viewModel?.form" form-area>
        <form #detailsForm="ngForm">
          <div class="tcm-details-panel">
            <div class="row">
              <div class="col-md-4">
                <waf-select-input name="translationId"
                                  [label]="'Screens.UserSettings.Details.Fields.Language' | translate"
                                  [(ngModel)]="viewModel.form.translationId"
                                  [options]="viewModel.translationOptions"
                                  [required]="true"></waf-select-input>
              </div>
              <div class="col-md-4">
                <waf-select-input name="defaultPage"
                                  [label]="'Screens.UserSettings.Details.Fields.DefaultPage' | translate"
                                  [(ngModel)]="viewModel.form.defaultPage"
                                  [options]="defaultPageOptions"
                                  [allowClear]="true"></waf-select-input>
              </div>
              <div class="col-md-4">
                <waf-select-input name="defaultClinicId"
                                  [label]="'Screens.UserSettings.Details.Fields.DefaultClinic' | translate"
                                  [(ngModel)]="viewModel.form.defaultClinicId"
                                  [options]="viewModel.clinicOptions"
                                  [allowClear]="true"></waf-select-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <waf-select-input name="schedulerDefaultView"
                                  [label]="'Screens.UserSettings.Details.Fields.SchedulerDefaultView' | translate"
                                  [(ngModel)]="viewModel.form.schedulerDefaultView"
                                  [options]="schedulerDefaultViewOptions"
                                  [allowClear]="true"></waf-select-input>
              </div>
              <div *ngIf="canEditTranslations" class="col-md-4">
                <waf-boolean-input name="trasnlationMode"
                                   controlIndicatorClass="toggle-button-control-indicator"
                                   [label]="'Screens.UserSettings.Details.Fields.TranslationMode' | translate"
                                   [(ngModel)]="viewModel.form.isTranslationMode"></waf-boolean-input>
              </div>
            </div>
          </div>
          <tabs class="mt-3">
            <tab tabTitle="{{ 'Screens.UserSettings.Details.Subscriptions.Title' | translate }}">
              <div class="tcm-details-panel">
                <div class="row">
                  <div class="col-md-12">
                    <user-settings-subscription-linked-collection
                        class="linked-collection"
                        [editable]="canEdit"
                        [sourceItems]="viewModel.form.userSubscriptions"
                        [clinicInitOptions]="viewModel.clinicOptions">
                    </user-settings-subscription-linked-collection>
                  </div>
                </div>
              </div>
            </tab>
          </tabs>
        </form>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>
